const Validation = {
  required: 'Trường thông tin bắt buộc',
  invalidEmail: 'Email không hợp lệ',
  invalidPhoneNumber: 'Số điện thoại không hợp lệ',
};

export default Validation;
